import { ReactNode, useState } from 'react'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/lemmala-design-system/popover/popover'

import { EmojiPicker } from './emoji-picker'

type EmojiPickerPopoverProps = {
  trigger: ReactNode
  onEmojiSelect: (emoji: string) => void
  frequentEmojis?: string[]
}

export const EmojiPickerPopover = ({
  trigger,
  onEmojiSelect,
  frequentEmojis,
}: EmojiPickerPopoverProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent
        align='end'
        className='w-auto border-0 bg-transparent p-0 shadow-none'
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <EmojiPicker
          frequentEmojis={frequentEmojis}
          onEmojiSelect={(emoji) => {
            onEmojiSelect(emoji)
            setOpen(false)
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
